import React, { useEffect } from 'react';

const GA_SCRIPT_ID = 'google-analytics';

const loadGoogleAnalytics = (measurementId) => {
  if (!measurementId) return;
  if (document.getElementById(GA_SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  script.id = GA_SCRIPT_ID;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  const gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  gtag('js', new Date());
  gtag('config', measurementId);
};

export default function Footer({ texts }) {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  const isConfigured = Boolean(measurementId);
  const displayId = measurementId || texts.footerPlaceholder;

  useEffect(() => {
    loadGoogleAnalytics(measurementId);
  }, [measurementId]);

  return (
    <footer className="footer">
      <div className="container footer-content">
        <div className="footer-bottom">
          <div className="footer-analytics">
            <span className="footer-label">{texts.footerAnalyticsLabel}</span>
            <code data-analytics-id={displayId}>{displayId}</code>
          </div>
          <span className={`footer-status ${isConfigured ? 'is-ready' : 'is-pending'}`}>
            {isConfigured ? texts.footerStatusReady : texts.footerStatusPending}
          </span>
        </div>
      </div>
    </footer>
  );
}
